import React, { useEffect } from 'react';
import { API_BASE_URL } from '../../api-base-url';
import { SectionNavbar } from '../section-navbar';
import { Festivals } from '../festivals';
import { Vendors } from '../vendors';
import { Performers } from '../performers';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';

export default function Home() {
  const clearFestivalWorkspace = useFestivalWorkspaceStore(
    (s) => s.clearFestivalWorkspace,
  );

  useEffect(() => {
    clearFestivalWorkspace();
  }, [clearFestivalWorkspace]);

  const sections = [
    {
      title: 'Festivals',
      component: <Festivals />,
    },
    {
      title: 'Vendors',
      component: <Vendors />,
    },
    {
      title: 'Performers',
      component: <Performers />,
    },
  ];

  const deployDate = import.meta.env.VITE_DEPLOY_DATE;

  return (
    <div className="flex min-h-full flex-col">
      <SectionNavbar navItems={sections} tabBarClassName="mt-12" />
      {(deployDate || API_BASE_URL) && (
        <div className="mt-auto px-6 py-6 text-center text-sm text-[var(--festy-muted-text)]">
          {deployDate && <div>Deploy date: {deployDate}</div>}
          {API_BASE_URL && <div>API URL: {API_BASE_URL}</div>}
        </div>
      )}
    </div>
  );
}
